import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list__item-loading-wrapper" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ListItemLoading',
  props: {
  itemsToRender: {
    type: Number,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemsToRender, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "list__item-loading-group"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "list__item-loading" }, null, -1),
        _createElementVNode("div", { class: "list__item-loading" }, null, -1)
      ])))
    }), 128))
  ]))
}
}

})